import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

const CpsApiPosterAPI = {
    state: {},
    mutations: {
      FetchUploadPoster(state, data) { // 上传
        data.url = API.CpsApiPoster.upload
        CommonUtils.PostRequest(data)
      },
      FetchGetPosterList(state, data) { // 获取列表
        data.url = API.CpsApiPoster.list
        CommonUtils.GetRequest(data)
      },
      FetchRemovePoster(state, data) { // 删除海报
        data.url = API.CpsApiPoster.remove
        CommonUtils.GetRequest(data)
      }
    }
}

export default CpsApiPosterAPI;



// WEBPACK FOOTER //
// ./src/store/modules/CpsApiPoster.js